export const ENDPOINTS = {
  auth: {
    me: '/auth/me',
    login: '/auth/login',
    register: '/auth/register',
    logout: '/auth/logout',
    refresh: '/auth/refresh',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
    verifyEmail: (token: string) => `/auth/verify-email?token=${token}`,
    resendVerify: '/auth/resend-verify',
    onboarding: '/auth/onboarding',
  },
  conversations: {
    list: '/conversations',
    create: '/conversations',
    detail: (id: string) => `/conversations/${id}`,
    messages: (id: string) => `/conversations/${id}/messages`,
    resolve: (id: string) => `/conversations/${id}/resolve`,
    archive: (id: string) => `/conversations/${id}/archive`,
  },
  notifications: {
    list: '/notifications',
  },
  billing: {
    status: '/billing/status',
    checkoutSession: '/billing/checkout-session',
    portalSession: '/billing/portal-session',
  },
  accounting: {
    status: '/accounting/status',
    qboConnect: '/accounting/qbo/connect',
    xeroConnect: '/accounting/xero/connect',
    disconnect: (provider: string) => `/accounting/${provider.toLowerCase()}/disconnect`,
    sync: '/accounting/sync',
    entity: (id: string) => `/accounting/entities/${id}`,
  },
  org: {
    settings: '/org/settings',
    members: '/org/members',
    memberRole: (id: string) => `/org/members/${id}/role`,
    member: (id: string) => `/org/members/${id}`,
    invitations: '/org/invitations',
    invite: '/org/invite',
  },
  monthlyClose: {
    list: '/monthly-close',
    detail: (id: string) => `/monthly-close/${id}`,
    export: (id: string) => `/monthly-close/${id}/export`,
  },
  upload: {
    presign: '/upload/presign',
  },
  users: {
    publicProfile: (id: string) => `/users/${id}/public`,
  },
  memory: {
    list: '/memory',
    create: '/memory',
    delete: (id: string) => `/memory/${id}`,
  },
  documents: {
    list: '/documents',
    detail: (id: string) => `/documents/${id}`,
    process: (id: string) => `/documents/${id}/process`,
    retry: (id: string) => `/documents/${id}/retry`,
  },
  reports: {
    summary: '/reports/summary',
    sendEmail: '/reports/send-email',
    pdf: '/reports/pdf',
    csv: '/reports/csv',
  },
  rules: {
    list: '/rules',
    detail: (id: string) => `/rules/${id}`,
  },
  reconciliation: {
    queue: '/reconciliation/queue',
    matches: '/reconciliation/matches',
    match: (id: string) => `/reconciliation/matches/${id}`,
    txCandidates: (transactionId: string) =>
      `/reconciliation/transactions/${transactionId}/candidates`,
    unmatchedDocs: '/reconciliation/documents/unmatched',
    matchTargets: '/reconciliation/match-targets',
    rules: '/reconciliation/rules',
  },
  tax: {
    settings: '/tax/settings',
    contractors: '/tax/contractors',
    contractor: (id: string) => `/tax/contractors/${id}`,
    prep1099: '/tax/1099-prep',
    scheduleC: '/tax/schedule-c-summary',
    stateEstimate: '/tax/state-estimate',
    deadlines: '/tax/deadlines',
    filingDrafts: '/tax/filing-drafts',
  },
  taxes: {
    settings: '/taxes/settings',
    summary: '/taxes/summary',
    saEstimate: '/taxes/sa-estimate',
    boxes: '/taxes/boxes',
    vatReturn: '/taxes/vat-return',
    mtdStatus: '/taxes/mtd-status',
    ct600: '/taxes/ct600',
    cisSubcontractors: '/taxes/cis/subcontractors',
    cisSubcontractor: (id: string) => `/taxes/cis/subcontractors/${id}`,
    cisVerify: (id: string) => `/taxes/cis/subcontractors/${id}/verify`,
    cis300: '/taxes/cis/cis300',
    deadlines: '/taxes/deadlines',
    filingDrafts: '/taxes/filing-drafts',
  },
} as const;
